module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/zen-observable/index.js
// module id = 3404
// module chunks = 0